<script setup>
import { ref } from "vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { Mail, ArrowLeft } from "lucide-vue-next";

const { toast } = useToast();
const isLoading = ref(false);
const email = ref("");
const isSent = ref(false);

const handleReset = async (e) => {
  e.preventDefault();
  isLoading.value = true;

  setTimeout(() => {
    isLoading.value = false;
    isSent.value = true;
    toast({
      title: "Correo enviado",
      description: "Revisa tu bandeja de entrada para restablecer tu contraseña.",
    });
  }, 1500);
};
</script>

<template>
  <AuthLayout>
    <div class="text-center mb-8">
      <h1 class="text-2xl font-bold text-foreground mb-2">Recuperar acceso</h1>
      <p class="text-sm text-muted-foreground">
        Ingresa tu email para recibir instrucciones
      </p>
    </div>

    <div v-if="isSent" class="text-center space-y-6">
      <div class="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto cyan-border-glow">
        <Mail class="w-8 h-8 text-accent" />
      </div>
      <p class="text-muted-foreground">
        Hemos enviado un enlace de recuperación a <strong>{{ email }}</strong>.
      </p>
      <Button 
        variant="outline" 
        class="w-full"
        @click="isSent = false"
      >
        Intentar con otro correo
      </Button>
    </div>

    <form v-else @submit="handleReset" class="space-y-6">
      <div class="space-y-2">
        <Label for="email">Correo electrónico</Label>
        <div class="relative">
          <Mail class="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          <Input 
            id="email" 
            type="email" 
            v-model="email"
            placeholder="tu@email.com" 
            class="pl-9 bg-background/50 border-border/50 focus:border-accent" 
            required
          />
        </div>
      </div>

      <Button 
        type="submit" 
        variant="hero-secondary" 
        class="w-full" 
        :disabled="isLoading"
      >
        {{ isLoading ? "Enviando..." : "Enviar enlace de recuperación" }}
      </Button>
    </form>

    <template #footer>
      <router-link 
        to="/login" 
        class="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
      >
        <ArrowLeft class="w-4 h-4" />
        Volver al inicio de sesión
      </router-link>
    </template>
  </AuthLayout>
</template>
